export const TERM = [
  {
    value: '20',
    label: '20 años',
  },
  {
    value: '10',
    label: '10 años',
  },
];

export const PREVENTA = [
  {
    value: 'si',
    label: 'Si',
  },
  {
    value: 'no',
    label: 'No',
  },
];
